module.exports = __webpack_public_path__ + "e1d912a18cdf1013aea9e9a8594d73f1.svg";